export const appleAppStoreLink = "https://apps.apple.com/us/app/notemeal/id1496444839?mt=8";
export const googlePlayStoreLink = "https://play.google.com/store/apps/details?id=io.notemeal.mobile";
